<template>
  <div
    @click="selectFile"
    class="multimedia__content-custom"
    role="button">
    <div
      class="multimedia__content-custom-icon">
      <slot></slot>
    </div>
    <div
      class="multimedia__content-custom-label">{{ label }}
    </div>
    <input
      ref="inputFile"
      :accept="accept"
      @change="onFileSelected"
      class="multimedia__content-custom-input"
      type="file"/>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: true,
      type: String,
    },
    accept: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
  },
  methods: {
    selectFile() {
      this.$refs.inputFile.click();
    },
    reset() {
      this.$refs.inputFile.value = null;
    },
    onFileSelected({ target: { files = [] } }) {
      if (!files.length) {
        return;
      }

      this.$emit('file-selected', files[0], this.type);
      this.reset();
    },
  },
};
</script>
